// extracted by mini-css-extract-plugin
export default {"medicationIcon":"styles_medicationIcon__WAIjT","medicationIconNoColor":"styles_medicationIconNoColor__nE3OS"};